import { lazy } from '@/service/lazy'

export default [{
  name: 'Instituições',
  path: 'instituicoes',
  id: 'instituicoes',
  icon: 'fa fa-university',
  component: lazy('app/default/gerenciador/instituicoes/index'),
  meta: { requireAuth: true, rules: ['gerenciar_instituicoes'] },
  children: []
}]



// WEBPACK FOOTER //
// ./src/router/modules/default/instituicoes.js